import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { Button, Modal } from '@beef/ui-kit';
import { ResultPopup } from 'components/Popups/ResultPopup';
import { RequestStatus } from '@beef/smart-kit';
import { SuccessPopupStatus } from './SuccessPopupStatus';

// Actions
import { disconnectFamilyService, setPopupStatus, setPopupStep } from '../../store/action';

// Constants
import { POPUP_STEPS } from '../../constants';

// Mocks
import mock from './mock';

// Utils
import { templateParser } from '../../../../utils/formatString';
import { maskPhoneNumber } from '../../../../utils/validators';

const FamilyChildPopup = () => {
  const dispatch = useDispatch();
  const { step, isOpen, ctn, isPopupLoading } = useSelector((state) => state.familyChild);

  const handleCloseModal = useCallback(() => {
    dispatch(setPopupStatus(false));
    dispatch(setPopupStep(POPUP_STEPS.disconnect));
  }, []);

  const maskedPhone = maskPhoneNumber(ctn);
  const disconnectPopupTitle = templateParser(mock.disconnect.title, { PHONE: maskedPhone });
  const disconnectionSucceededTitle = templateParser(mock.success.title, { PHONE: maskedPhone });

  const handleDisconnectBtnClick = useCallback(() => {
    dispatch(disconnectFamilyService(ctn));
  }, [ctn]);

  const confirmBtnClick = useCallback(() => {
    dispatch(setPopupStatus(false));
    window.location.reload();
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      isCentered
      onClose={handleCloseModal}
      size="s"
    >
      {step === POPUP_STEPS.disconnect && (
        <ResultPopup
          hasButtons
          imageUrl={mock.disconnect.imageUrl}
          title={disconnectPopupTitle}
          description={mock.disconnect.description}
          onClick={handleDisconnectBtnClick}
          inProgress={isPopupLoading}
          buttonText={mock.disconnect.buttonGroup[0].buttonText}
        >
          <Button size="m" variant="tertiary" onClick={handleCloseModal}>
            {mock.disconnect.buttonGroup[1].buttonText}
          </Button>
        </ResultPopup>
      )}
      {step === POPUP_STEPS.error && (
        <RequestStatus
          button={{
            text: mock.error.buttonText,
            size: 'm',
            variant: 'secondary',
          }}
          description={mock.error.description}
          img={{
            src: mock.error.imageUrl,
          }}
          title={mock.error.title}
          onConfirm={confirmBtnClick}
        />
      )}
      {step === POPUP_STEPS.success && (
        <RequestStatus
          button={{
            text: mock.success.buttonText,
            size: 'm',
            variant: 'secondary',
          }}
          description={<SuccessPopupStatus />}
          img={{
            src: mock.success.imageUrl,
          }}
          title={disconnectionSucceededTitle}
          onConfirm={confirmBtnClick}
        />
      )}
    </Modal>
  );
};

export { FamilyChildPopup };
